export enum UserRole {
  Student = 'student',
  Teacher = 'teacher',
  Author = 'author',
}
export function getUserRoles(): UserRole[] {
  return [UserRole.Student, UserRole.Teacher, UserRole.Author];
}
export function getUserRoleFrom(value: string): UserRole | undefined {
  return getUserRoles().find(type => type === value);
}